<template>
  <div>
    <div id="wrapper" class="d-flex">
      <div id="page-content-wrapper">
        <nav
          class="navbar navbar-expand-lg navbar-light bg-na-principal border-bottom fixed-top custom-navbar"
          :class="{ 'mobile-responsive': isMobile }"
        >
          <hamburger v-if="isMobile" class="pl-4" />
          <div
            v-if="!isMobile"
            class="sidebar-menu-button"
            :class="{ active: isNavOpened }"
          >
            <hamburger :color="'bg-white'" :show-title="true" />
          </div>
          <div class="sidebar-heading">
            <img alt="logo" height="63px" :src="logoImgUrl" width="190px" />
          </div>
          <div
            id="navbarSupportedContent"
            class="collapse navbar-collapse show float-right left"
          >
            <ul
              class="navbar-nav mr-auto mt-2 mt-lg-0 d-flex align-items-center"
            >
              <li>
                <droppable
                  class="action-item-search"
                  :show="true"
                  @click="onOpenSearchStudentHandler"
                >
                  <div class="media align-items-center">
                    <span
                      class="avatar avatar-sm bg-gray-7 border-none rounded-circle"
                    >
                      <em class="fas fa-search font-20" />
                    </span>
                  </div>
                  <template #drop>
                    <student-search
                      ref="studentSearchRef"
                      :can-select-student="false"
                      :can-view-history="false"
                      :get-advanced-search="getAdvancedSearch"
                      :get-impediments="getImpediments"
                      :get-student-by-sie="getStudentBySie"
                      :is-mobile="isMobile"
                      @on-view-student="onViewStudentHandler"
                    />
                  </template>
                </droppable>
                <droppable v-if="false" class="action-item-help">
                  <div class="media align-items-center">
                    <span class="avatar avatar-sm rounded-circle deticket">
                      <em class="fal fa-user-headset color-white" />
                    </span>
                  </div>

                  <template #drop>
                    <div
                      class="deticket-box dropdown-list dropdown-menu dropdown-menu-custom custom-right show mt-4"
                    >
                      <div
                        class="cursor-pointer"
                        @click="onNavigateToCreateTicket"
                      >
                        <div class="dropdown-item nav-list-item">
                          <em
                            class="fas fa-file-plus font-20 color-green mr-2"
                          />
                          <div
                            class="color-black font-16 font-weight-normal ml-2 pl-1"
                          >
                            Crear Solicitud
                          </div>
                        </div>
                      </div>

                      <div
                        class="cursor-pointer"
                        @click="onNavigateToViewTickets"
                      >
                        <div class="dropdown-item nav-list-item">
                          <em
                            class="fas fa-file-search font-20 color-green mr-2"
                          />
                          <div
                            class="color-black font-16 font-weight-normal ml-1"
                          >
                            Ver Solicitudes
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="deticket-box dropdown-menu show">
                      <div
                        class="dropdown-item nav-list-item cursor-pointer d-flex"
                        @click="onNavigateToCreateTicket"
                      >
                        <em class="fas fa-file-plus font-20 color-green mr-2" />
                        <div
                          class="color-black font-16 font-weight-normal ml-1"
                        >
                          Crear Solicitud
                        </div>
                      </div>

                      <div
                        class="dropdown-item nav-list-item cursor-pointer d-flex"
                        @click="onNavigateToViewTickets"
                      >
                        <em
                          class="fas fa-file-search font-20 color-green mr-2"
                        />
                        <div
                          class="color-black font-16 font-weight-normal ml-1"
                        >
                          Ver Solicitudes
                        </div>
                      </div>
                    </div> -->
                  </template>
                </droppable>
                <droppable class="action-item-notification">
                  <div class="media align-items-center">
                    <span class="avatar avatar-sm rounded-circle">
                      <em class="fas fa-bell color-green" />
                    </span>
                  </div>
                </droppable>

                <droppable v-if="false" class="action-item-help">
                  <div class="media align-items-center">
                    <span class="avatar avatar-sm rounded-circle">
                      <em class="fal fa-question-circle color-green" />
                    </span>
                  </div>
                  <template #drop>
                    <card
                      class="position-relative nav-card top-60 w-card"
                      :row-elements="helpCard.rowElements"
                    >
                      <template #section-bottom>
                        <div class="row">
                          <div class="col-12 mb-2">
                            <span class="font-15">
                              Mesa de Apoyo
                            </span>
                          </div>
                          <div class="col-12">
                            <Link
                              color="gray-6"
                              color-icon="gray-7"
                              icon="fas fa-phone-alt"
                              :text="contactInfo.phone"
                              :with-border="false"
                            />
                          </div>
                          <div class="col-12">
                            <Link
                              color="gray-6"
                              color-icon="gray-7"
                              icon="fas fa-envelope"
                              :text="contactInfo.mail"
                              :with-border="false"
                            />
                          </div>
                        </div>
                      </template>
                    </card>
                  </template>
                </droppable>
              </li>
              <li v-if="userHasPermissions('provider.help.view')" class="mr-2">
                <div class="dropdown dropdown-help">
                  <button
                    id="btnhelp"
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="btn btn-secondary dropdown-toggle d-flex align-items-center dropdown-toggle-help"
                    data-toggle="dropdown"
                    type="button"
                  >
                    <img
                      alt="circle-question"
                      class="mr-2"
                      src="@/assets/img/circle-question.svg"
                    />
                    Ayuda
                  </button>
                  <div aria-labelledby="btnhelp" class="dropdown-menu mt-1">
                    <a
                      v-if="
                        userHasPermissions('provider.help.createticket.view')
                      "
                      class="dropdown-item d-flex align-items-center cursor-pointer"
                      @click="handleOpenCloseTicketFlow"
                    >
                      <img
                        alt="circle-plus"
                        class="mr-2 ml-n2"
                        src="@/assets/img/circle-plus-green.svg"
                      />
                      Crear un Ticket
                    </a>
                    <a
                      v-if="userHasPermissions('provider.chatbotbtn')"
                      class="dropdown-item d-flex align-items-center cursor-pointer"
                      @click="handleOpenCloseVirtualAssistant"
                    >
                      <img
                        alt="sparkles"
                        class="mr-2 ml-n2"
                        src="@/assets/img/sparkles.svg"
                      />
                      Asistente Virtual
                    </a>
                    <a
                      v-if="userHasPermissions('provider.help.mytickets.view')"
                      class="dropdown-item d-flex align-items-center cursor-pointer"
                      @click="handleNavigateToMyTickets"
                    >
                      <img
                        alt="ticket"
                        class="mr-2 ml-n2"
                        src="@/assets/img/ticket.svg"
                      />
                      Mis Tickets
                    </a>
                  </div>
                </div>
              </li>
              <li>
                <custom-user-info
                  class="ml-3 custom-user-info"
                  :last-login-date="new Date(userInfo.lastlogindate)"
                  :row-actions="userCard.rowActions"
                  :row-elements="userCard.rowElements"
                />
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
    <modal-password
      :show="displayChangeUserPassword"
      @on-close="onClosing"
      @submit="changePassword"
    />
    <student-search-info
      :academic-years="academicYears"
      :enrollment-school-data="enrollmentSchoolData"
      :pei-history-data="peiHistoryData"
      :show="showStudentInfo"
      :show-therapy-tab="false"
      :status-list="studentStatuses"
      :student-info="studentInfo"
      :therapies="[]"
      @loadenrollmentSchoolData="loadenrollmentSchoolData"
      @on-close="onCloseHandler"
      @on-search-pei-history="onSearchPeiHistoryHandler"
    />
    <my-profile
      v-if="profileModalVisible"
      v-model="profileModalVisible"
      :save-profile="updateMyProfile"
      :user-info="{ ...userInfo, roleId: userInfo.roleid }"
    />
    <profile-info
      v-if="updateProfileVisible"
      :save-profile="updateMyProfile"
      :user="userInfo"
      value
      @close="updateProfileVisibleHandler"
    />
    <ticket-flow :email="userInfo.email" @close="handleOpenCloseTicketFlow" />
    <virtual-assistant
      :user-full-name="userFullName"
      @close="handleOpenCloseVirtualAssistant"
    />
  </div>
</template>

<script>
import { name as appModuleName } from '@/modules/app/store/index';
import { mapGetters, mapState, mapMutations } from 'vuex';
import Card from './card';
import Hamburger from './hamburger';
import CustomUserInfo from 'CustomUserInfoPanel';
import StudentSearch from 'student-search';
import StudentSearchInfo from 'student-search-info';
import ModalPassword from '@quisit/mipe-modal-password';
import TicketFlow from '@/views/helpdesk/ticket-flow';
import VirtualAssistant from '@/views/helpdesk/virtual-assistant';
import Droppable from 'custom-droppable';
import { MyProfile, ProfileInfo } from 'mipe-security';
import { updateMyProfile as _updateMyProfile } from '@/modules/user/api.js';
import {
  getBySie as _getBySie,
  getImpediments as _getImpediments,
  getAdvancedSearch as _getAdvancedSearch,
  getPeiHistory as _getPeiHistory,
  getAcademicYears as _getAcademicYears,
  getStudentEnrollmentDetail as _getStudentEnrollmentDetail,
  getStudentDetailsBySie as _getStudentDetailsBySie,
  getStudentStatuses as _getStudentStatuses,
} from '@/modules/student/api.js';
import { changeUserPassword as _ChangeUserPassword } from '@/modules/user/api';
import alert from '@quisit/mipe-utils/mixins/alert.mixin';

const CASE_LIST_ROUTE_NAME = 'CaseListMain';
const CREATE_CASE_ROUTE_NAME = 'CreateTicket';
const KEY_PROFILE_UPDATED = 'profile-update-flag';
const DEFAULT_PEI_HISTORY_PAGE_SIZE = 10;

import logoUrl from '@/assets/img/logo.png';
import logoTrainingUrl from '@/assets/img/logo-training.svg';

export default {
  components: {
    Droppable,
    Card,
    Hamburger,
    CustomUserInfo,
    StudentSearch,
    StudentSearchInfo,
    MyProfile,
    ProfileInfo,
    ModalPassword,
    TicketFlow,
    VirtualAssistant,
  },
  mixins: [alert],
  props: {
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    excludeHelpCard: {
      type: Array,
      default: () => [], //array strings, para excluir items de caja de ayuda
    },
    contactInfo: {
      type: Object,
      default: () => ({
        phone: '787-773-6147',
        mail: 'apoyoconversion@de.pr.gov',
      }),
    },
    logout: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isUserPasswordChangeVisible: false,
      isStudentForView: false,
      profileModalVisible: false,
      updateProfileVisible: false,
      studentInfo: {},
      enrollmentSchoolData: [],
      peiHistoryData: {},
      academicYears: [],
      therapies: [],
      studentStatuses: [],
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
      isNavOpened: 'getIsNavOpen',
    }),
    ...mapState(appModuleName, [
      'showStudentInfo',
      'selectedStudentId',
      'isOpenSearchStudent',
    ]),
    displayChangeUserPassword() {
      return this.isUserPasswordChangeVisible;
    },
    userCard() {
      return {
        rowElements: [
          {
            text: this.userInfo.role,
            icon: 'fas fa-key',
            colorIcon: 'orange',
            color: 'none',
            withBorder: false,
          },
          {
            text: this.userInfo.name,
            icon: 'fas fa-user',
            colorIcon: 'orange',
            color: 'none',
            withBorder: false,
          },
          {
            text: this.userInfo.email,
            icon: 'fas fa-envelope',
            colorIcon: 'orange',
            color: 'none',
            withBorder: false,
          },
        ],
        rowActions: [
          {
            text: 'Mi Perfil',
            icon: 'fas fa-address-card',
            colorIcon: 'green',
            color: 'green',
            withBorder: true,
            click: () => this.profileModalVisibilityHandler(true),
          },
          {
            text: 'Cambiar Contraseña',
            icon: 'fas fa-repeat-alt',
            colorIcon: 'green',
            color: 'green',
            withBorder: true,
            click: this.ShowHidePasswordChange,
          },
          {
            text: 'Salir',
            icon: 'fas fa-sign-out-alt',
            colorIcon: 'green',
            color: 'green',
            withBorder: true,
            click: () => this.logout(),
          },
        ],
      };
    },
    helpCard() {
      let rowElements = [
        { text: 'Manual', icon: 'fas fa-book' },
        { text: 'Videos', icon: 'fas fa-video' },
      ];
      return {
        rowElements: rowElements.filter(
          (item) => !this.excludeHelpCard.includes(item.text)
        ),
      };
    },
    logoImgUrl() {
      if (this.isTrainingEnv()) return logoTrainingUrl;
      return logoUrl;
    },
    userFullName() {
      return this.userInfo.givenname?.trim();
    },
  },
  mounted() {
    this.updateProfileVisibleHandler();
  },
  methods: {
    ...mapMutations(appModuleName, [
      'setShowStudentInfo',
      'setSelectedStudentId',
    ]),
    ShowHidePasswordChange() {
      this.isUserPasswordChangeVisible = true;
    },
    onClosing() {
      this.isUserPasswordChangeVisible = false;
    },
    onOpenSearchStudentHandler() {
      this.$refs.studentSearchRef.showModal();
    },
    onNavigateToViewTickets() {
      this.$router.push({
        name: CASE_LIST_ROUTE_NAME,
      });
    },
    onNavigateToCreateTicket() {
      this.$router.push({
        name: CREATE_CASE_ROUTE_NAME,
      });
    },
    profileModalVisibilityHandler(state) {
      this.profileModalVisible = state;
    },
    updateMyProfile(params) {
      return _updateMyProfile(params);
    },
    updateProfileVisibleHandler(value) {
      if (value != null) {
        sessionStorage.setItem(KEY_PROFILE_UPDATED, value);
      }
      this.updateProfileVisible =
        sessionStorage.getItem(KEY_PROFILE_UPDATED) === 'true';
    },
    getStudentBySie(studentSieId, webServiceSearchOnly) {
      return _getBySie(studentSieId, webServiceSearchOnly);
    },
    getImpediments() {
      return _getImpediments();
    },
    getAdvancedSearch(payload) {
      return _getAdvancedSearch(payload);
    },
    async onViewStudentHandler(student) {
      if (student) {
        const studentSieId = student.studentId;
        this.studentInfo = {};
        this.setShowStudentInfo(true);
        this.setSelectedStudentId(student.studentId);

        //get student enrollent school info
        this.studentInfo = (await _getStudentDetailsBySie(studentSieId)).data;

        //get pei history data
        await this.getPeiHistory(studentSieId);

        //get academic years list
        this.academicYears = (await _getAcademicYears()).data;

        //get student statuses
        const studentStatusCode =
          +this.studentInfo?.mipeStudent?.studentStatusCode || null;
        this.studentStatuses = (
          await _getStudentStatuses(studentStatusCode)
        ).data;

        this.$refs.studentSearchRef.hideModal();
      }
    },
    async getPeiHistory(studentSieId, year = 0, pageIndex = 1) {
      const result = (
        await _getPeiHistory(
          studentSieId,
          year,
          pageIndex,
          DEFAULT_PEI_HISTORY_PAGE_SIZE
        )
      ).data;

      this.peiHistoryData = {
        ...result,
        pageSize: DEFAULT_PEI_HISTORY_PAGE_SIZE,
      };
    },
    async onSearchPeiHistoryHandler(academicYear, studentSieId, pageIndex) {
      if (studentSieId) {
        await this.getPeiHistory(studentSieId, academicYear, pageIndex);
      }
    },
    async loadenrollmentSchoolData(studentId) {
      await this.getEnrollmentSchool(studentId);
    },
    async getEnrollmentSchool(studentSieId) {
      const result = (await _getStudentEnrollmentDetail(studentSieId)).data;

      this.enrollmentSchoolData = result?.map((item) => {
        let Ada = item.adaIndicator == '1' ? 'SÍ' : 'NO';
        Ada = item.adaIndicator == null ? 'No disponible' : Ada;
        return {
          schoolYear: item.schoolYear,
          effectiveStartDate: `${item.effectiveStarDate}`,
          effectiveEndDate: `${item.effectiveEndDate}`,
          region: `${item.region}`,
          district: `${item.district}`,
          school: `${item.extNumber} - ${item.name}`,
          adaIndicator: Ada,
          gradeLevel: item.gradeLevel,
          status: item.enrollmentEndStatusDescription,
        };
      });
    },
    onCloseHandler() {
      this.setShowStudentInfo(false);
    },
    async changePassword(e) {
      let data = {
        currentPassword: e.currentPassword,
        confirmPassword: e.confirmPassword,
        newPassword: e.newPassword,
      };

      await _ChangeUserPassword(data)
        .then((response) => {
          if (!response.error) {
            this.onClosing();

            this.ShowToast(
              'Proceso Exitoso',
              'Su contraseña ha sido cambiada exitosamente.',
              'success'
            );
            this.$emit('on-closing');
          }
        })
        .catch((error) => {
          this.ShowToast('', error.response.data.message, 'error');
        });
    },
    handleOpenCloseTicketFlow() {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-create-ticket');
    },
    handleOpenCloseVirtualAssistant() {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-virtual-assistant');
    },
    handleNavigateToMyTickets() {
      this.$router.push({ name: 'CaseListMain' });
    },
  },
};
</script>

<style scoped>
.div-help {
  margin-left: -10px;
  color: #ff7058;
}
.help-text {
  margin-left: -10px;
}
.help-information {
  margin-left: -10px !important;
}
.information-text {
  margin-left: -7px;
  font-family: 'Lato', sans-serif;
  font-size: 12px;
}
.support-table {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  opacity: 1;
}
.support-information {
  text-align: left;
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #20a874 !important;
  opacity: 1;
}
.support-label {
  margin-left: 11px !important;
  text-decoration: underline;
  font-family: 'Lato', sans-serif;
  font-size: 13px;
}
.shadow-top {
  -moz-box-shadow: inset 0 10px 10px -10px grey;
  -webkit-box-shadow: inset 0 10px 10px -10px grey;
  box-shadow: inset 0 10px 10px -10px grey;
}
.alert-indicator {
  position: absolute;
  top: 32px;
  right: 157px;
  background: #fd3737 0% 0% no-repeat padding-box;
  color: #fff;
  width: 15px;
  height: 15px;
  opacity: 1;
  line-height: 15px;
  text-align: center;
  font-size: 10px;
}

.dropdown-menu-custom {
  top: 95% !important;
}

.nav-item .media {
  margin-left: 20px;
}

.nav-item .media em {
  font-size: 1.225rem;
}

.user-panel {
  margin-right: 10rem;
}

.nav-list-item {
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  padding: 15px 15px;
}

.custom-user-info ::v-deep > .user-panel > .dropdown-menu {
  top: 80px;
  margin-right: 0.3rem;
  min-width: 15rem;
}

.sidebar-menu-button {
  background-color: #3f5b60;
  width: 118px;
  height: 85px;
  padding-top: 16px;
}

.sidebar-menu-button.active {
  background-color: #b5c3bc;
}

.dropdown-help button {
  border-radius: 52px;
  background: #ff7058 !important;
  padding: 8px 17px !important;
  border: unset !important;
  margin-left: 20px;
}

.dropdown-help button:focus {
  box-shadow: unset !important;
}

.dropdown-help button:after {
  border: none;
  font-family: 'Font Awesome 5 Pro';
  content: '\f107';
  margin-left: 0.5rem;
  color: #fff;
}

.dropdown-help .dropdown-menu .dropdown-item {
  margin-bottom: 7px;
}

.dropdown-help .dropdown-menu .dropdown-item:active img {
  background: #fff !important;
}

@media screen and (max-width: 991px) and (min-width: 768px) {
  .custom-user-info ::v-deep > .user-panel > .dropdown-menu {
    top: 5rem;
    margin-right: 0.3rem;
    min-width: 15rem;
  }

  ul.navbar-nav {
    height: 55px;
    width: 42%;
  }

  ul.navbar-nav li:nth-child(2) {
    margin-top: -4.19rem;
  }
}

@media screen and (max-width: 767px) {
  .custom-user-info ::v-deep > .user-panel > .dropdown-menu {
    top: 5rem;
    margin-right: -0.9rem;
    min-width: 15rem;
  }
}
</style>
